import { createSchema } from "../erd-editor-schema/dist/v3/parser/index.js";
import { toJson } from "../erd-editor-schema/dist/parser.js";
import { toSafeString } from "./validation.js";
import { isEmpty } from "es-toolkit/compat";
//#region src/utils/loadValue.ts
function toLoadValue(value) {
	const safeValue = toSafeString(value);
	return isEmpty(safeValue) ? toJson(createSchema()) : safeValue;
}
//#endregion
export { toLoadValue };
